///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promo = abcsetup.promo || {};
abcsetup.promo.promo_plan = abcsetup.promo.promo_plan || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promo.promo_plan.index = {
    init: function() {
        abcsetup.setTitle('Manage Users');

        // Init datatables
        datatable = abcsetup.datatables.init($('table#promo_plans'), {
            bInfo: true,
            scroll_horizontal: true,
            "responsive": false,
            "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
            "iDisplayLength": 25,
            /*
            "columnDefs": [{
                "targets": [34],
                "orderable": false
            }],
            */
            "order": [[0, "asc"]],
            serverSide: true,
            "colReorder": false,
            //processing: true,
            // Add the "Add New" button to the datatable
            // "addBtn": '/users/create',
            // "addText": '<i class="fas fa-plus-square"></i> Add User',
            ajax: "/api/promo_plans/datatable",
            columns: [
                { name: 'status' },
                { name: 'type' },
                { name: 'start_run'},
                //{ name: 'total_dollars'},
                //{ name: 'categories'},
                { name: 'action', orderable: false, searchable: false }
            ],
        });

        abcsetup.users.index.datatable = datatable;

    },

    datatable: {},

        /**
     *
     * @param {*} id
     */
    delete: function(id) {
        axios.delete('/users/' + id).then(response => {
            abcsetup.users.index.datatable.ajax.reload();
        });
    },
    reset_mfa: function(id) {
        axios.post('/users/reset_mfa',{
            id : id
        }).then(response => {
            abcsetup.users.index.datatable.ajax.reload();
        });
    }
}
